import { render } from "./LoadIIIFModal.vue?vue&type=template&id=0115c872&scoped=true"
import script from "./LoadIIIFModal.vue?vue&type=script&lang=js"
export * from "./LoadIIIFModal.vue?vue&type=script&lang=js"

import "./LoadIIIFModal.vue?vue&type=style&index=0&id=0115c872&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0115c872"]])

export default __exports__